/** @jsxImportSource @emotion/react */
import React, { PropsWithChildren } from 'react';
import { jsx, css } from '@emotion/react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { LinkProps, useHref } from 'react-router-dom';

const defaultProps = {};
type DropdownItemProps = React.ComponentProps<typeof DropdownItem>;
type Props = DropdownItemProps & {
  to: LinkProps['to'];
} & typeof defaultProps;

const DropdownLinkItem = ({to, ...props}: PropsWithChildren<Props>) => {
  const href = useHref(to);
  return (<DropdownItem href={href} {...props}/>);
};

DropdownLinkItem.defaultProps = defaultProps;

export default DropdownLinkItem;
